var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg63 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M25.58 12.398a5.64 5.64 0 0 1 5.235 3.519l.083.22.265.75h-9.436l-2.395 8.505H18.06a3.255 3.255 0 0 1-3.266-3.245 3.254 3.254 0 0 1 3.08-3.24l.186-.005h1.787l.116-1.373c.244-2.889 2.681-5.131 5.618-5.131m-9.6-4.899a7.79 7.79 0 0 1 6.79 3.971 7.12 7.12 0 0 0-4.272 5.658l-.029.275h-.41c-2.631 0-4.764 2.124-4.764 4.744 0 1.172.426 2.245 1.133 3.073l.156.173H6.198A4.698 4.698 0 0 1 5.983 16l.215-.005h1.911l.115-1.374A7.785 7.785 0 0 1 15.981 7.5m17.218 9.567c2.314 0 4.188 1.865 4.188 4.163 0 2.228-1.762 4.05-3.978 4.159l-.21.005h-.817l1.516-2.519h-5.222l2.57-5.76.069.194 1.228-.192q.324-.05.656-.05"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FED100",
  d: "M24.798 27.874h-4.606l2.671-9.487h6.171l-2.67 5.987h4.88L22.22 39.387z"
}))));
export { Svg63 as ReactComponent };